import { useEffect, useState } from 'react'

type Theme = 'light' | 'dark'
const THEME_KEY = 'xml_insights_theme'

function loadTheme(): Theme {
  const stored = localStorage.getItem(THEME_KEY)
  if (stored === 'dark' || stored === 'light') return stored
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
  localStorage.setItem(THEME_KEY, theme)
}

export function useDarkMode() {
  const [theme, setThemeState] = useState<Theme>(loadTheme)
  useEffect(() => { applyTheme(theme) }, [theme])
  const toggleTheme = () => setThemeState(t => t === 'dark' ? 'light' : 'dark')
  return { theme, toggleTheme }
}
